import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { Store } from '@ngrx/store';
import { RelativeNavigation } from "@nx/mono-common";
import { SignInStore } from '../interfaces/sign-in-store.interface';
import { UpdateSignInStore, SignInUser, SigningInUser, UpdatingSignInStore, SignInDestroy } from '../store/sign-in.actions';
import { signInPendingSelector, signInStoreSelector } from '../store/sign-in.selectors';
import { ClientMetadata } from 'libs/auth/src/lib/interfaces/client-meta-data.interface';


@Injectable({
  providedIn: 'root'
})
export class SignInService {

  constructor(private signInStore: Store<SignInStore>) { }

  public selectSignInStore(): Observable<SignInStore> {
    return this.signInStore.select(signInStoreSelector);
  }

  public selectSignInPending(): Observable<boolean> {
    return this.signInStore.select(signInPendingSelector);
  }

  public dispatchUpdatingSignInStore(pending: boolean) {
    this.signInStore.dispatch(UpdatingSignInStore({pending: pending}))
  }

  public dispatchUpdateSignInStore(updatedSignIn: SignInStore, signInAttribute?: string, relativeNavigation?: RelativeNavigation) {
    Object.freeze(relativeNavigation);
    this.signInStore.dispatch(UpdateSignInStore({ updatedSignIn: updatedSignIn, signInAttribute:signInAttribute, relativeNavigation: relativeNavigation }))
  }

  public dispatchSignInUser(signInAttribute: string, password: string, clientMetaData?: ClientMetadata) {
    this.signInStore.dispatch(SignInUser({ signInAttribute, password, clientMetaData }))
  }

  public dispatchSigningInUser(pending: boolean) {
    this.signInStore.dispatch(SigningInUser({ pending: pending }))
  }

  public dispatchResetSignInStore() {
    return this.signInStore.dispatch(SignInDestroy());
  }

}
